// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3641":"css/admin-app.6890","4661":"css/app.6890"}[chunkId] + ".css";
};